import { AI_VALUES } from "../content";
import { AiSectionHead } from "./AiSection";

/** 客户价值：8 张价值卡，后 4 张带「深度一体化能力」标记。对应设计稿第 7 节。 */
export default function AiValues() {
  return (
    <section aria-labelledby="ai-values-h" className="py-14 lg:py-20">
      <div className="rounded-3xl bg-[#f8fafc] border border-gray-100 px-6 lg:px-10 py-12 lg:py-16">
        <AiSectionHead eyebrow={AI_VALUES.eyebrow} title={AI_VALUES.title} sub={AI_VALUES.sub} />
        <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {AI_VALUES.items.map((v) => (
            <article
              key={v.title}
              className="flex gap-5 items-start p-6 rounded-2xl bg-white border border-gray-200 transition-all duration-200 hover:-translate-y-[3px] hover:shadow-[0_4px_14px_rgba(13,31,60,0.08)]"
            >
              <span className="shrink-0 w-[46px] h-[46px] rounded-[10px] grid place-items-center text-xl text-white bg-gradient-to-br from-[#1a56db] to-[#22d3ee]">
                <i className={v.icon}></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-[15px] font-bold text-[#0d1f3c] mb-2">{v.title}</h3>
                <p className="m-0 text-sm text-[#475569] leading-relaxed">{v.desc}</p>
                {v.unique && (
                  <span className="inline-block mt-3 text-[11px] font-bold tracking-wide px-[9px] py-[3px] rounded-full bg-[#b45309]/9 text-[#b45309] border border-[#b45309]/25">
                    深度一体化能力
                  </span>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
